import React from "react";
import { MHW_MAINTENANCE } from "../../constants/maintenance";
import { useMhwMaintenance } from "../../hooks/useMhwMaintenance";
import { useNavigation } from "../../hooks/useNavigation";
import { Button } from "../catalyst/button";
import Icon from "../ui/Icon";

interface MhwMaintenanceGuardProps {
  children: React.ReactNode;
}

/**
 * 의정원 중계를 거치는 화면을 감싼다. 점검 시간창 안이면 화면 대신 안내 페이지를 보여준다.
 */
const MhwMaintenanceGuard: React.FC<MhwMaintenanceGuardProps> = ({
  children,
}) => {
  const isActive = useMhwMaintenance();
  const { navigateToHome } = useNavigation();

  if (!isActive) return <>{children}</>;

  return (
    <div className="h-screen-dvh bg-white flex flex-col">
      <main className="flex-1 flex flex-col items-center justify-center px-6 text-center">
        <div className="w-16 h-16 rounded-full bg-yellow-100 flex items-center justify-center mb-5">
          <Icon name="alertTriangle" size="xl" className="text-yellow-700" />
        </div>
        <h1 className="text-xl font-semibold text-text-primary">
          건강정보 연동 기능 점검 중입니다
        </h1>
        <p className="text-m text-text-secondary mt-3 leading-relaxed">
          한국보건의료정보원 시스템 점검으로
          <br />
          로그인·회원가입·의료기록 연동을
          <br />
          잠시 이용할 수 없습니다.
        </p>
        <div className="mt-5 w-full max-w-sm rounded-xl bg-bg-background px-4 py-3">
          <p className="text-xs text-text-tertiary">점검 시간</p>
          <p className="text-s font-semibold text-text-primary mt-0.5">
            {MHW_MAINTENANCE.periodLabel}
          </p>
        </div>
        <p className="text-s text-text-secondary mt-5">
          AI 상담은 계속 이용할 수 있습니다.
          <br />
          점검이 끝난 뒤 다시 시도해 주세요.
        </p>
      </main>
      <div className="p-4">
        <Button
          color="zinc"
          className="w-full py-4 text-l"
          onClick={navigateToHome}
        >
          <span className="font-medium">홈으로 돌아가기</span>
        </Button>
      </div>
    </div>
  );
};

export default MhwMaintenanceGuard;
